import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Blog from "./Blog";

@Model()
class BlogPost extends ApplicationRecord {
  static jsonapiType = "blog_posts";

  @Attr() author: string;

  @Attr() blogId: number;

  @Attr() body: string;

  @Attr() comment: boolean;

  @Attr({ persist: false }) createdAt: string;

  @Attr() externalId: string;

  @Attr() publishedAt: string;

  @BelongsTo() source: Blog;

  @Attr() title: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() urlHash: string;
}

export default BlogPost;
